export const environment = {
  production: false,
  apiUrl: "https://localhost:44382/api",
  //apiUrl: "http://localhost:1989/api",
  //apiUrl: "https://storeapi.kasoft.vn/api",
  syncLive: false,
  realtime: false,
  allowRegister: true,
  validateBarcode: false,
  lockedDays: 5,
  companyId: "AEF5EBC9-11AF-46B1-B1C7-99C25DB92A3D",
  visibility: "public",
  logoUrl: "/assets/images/kasoft.png",
  regionLocation: "asia-southeast1",
  functionsUrl:
    "https://asia-southeast1-kasoft-store-0939965771.cloudfunctions.net/",
  firebase: {
    apiKey: "AIzaSyCusGibRZ2P-KUpUfEd7s7gn1sVz7bLQMA",
    authDomain: "kasoft-store-0939965771.firebaseapp.com",
    projectId: "kasoft-store-0939965771",
    storageBucket: "kasoft-store-0939965771.appspot.com",
    messagingSenderId: "777975216509",
    appId: "1:777975216509:web:488fc3e475a7bf2c587414",
    measurementId: "G-1YBGQE1J1T",
  },
  recaptcha: "6LdJqgQhAAAAADhfv097Ffn1SR53Eydw5teG_KPm",
  appCheck: false,
  formatCurrency: "#,###,###,###",
  imageKit: {
    publicKey: "public_LGFaPuvRvxAC08h5DJWOcsI+BH8=",
    urlEndpoint: "https://ik.imagekit.io/kasoft",
    authenticationEndpoint:
      "https://asia-southeast1-kasoft-store.cloudfunctions.net/imagekit-auth",
    urlServer: "https://upload.imagekit.io/api/v1/files/upload",
  },
};
